module.exports = __webpack_public_path__ + "daze.11e18eb1.png";